// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + "." + {"2897":"8c3b8604c8dfd0e34317","6400":"8ad557cb354770755570"}[chunkId] + ".js";
};